import { Timestamp } from 'firebase/firestore';

export enum ChatScheduleTypes {
    CLEAR_SCHEDULE_ERROR = '@chatSchedule/CLEAR_SCHEDULE_ERROR',
    SCHEDULE_ERROR_SAVING = '@chatSchedule/SCHEDULE_ERROR_SAVING',
    SCHEDULE_ERROR_LOADING = '@chatSchedule/SCHEDULE_ERROR_SAVING',

    DELETE_SCHEDULE = '@chatSchedule/DELETE_SCHEDULE',
    GET_SCHEDULES = '@chatSchedule/GET_SCHEDULES',
    UPSERT_SCHEDULE = '@chatSchedule/UPSERT_SCHEDULE',

    REQUEST_ADD_SCHEDULE = '@chatSchedule/REQUEST_ADD_SCHEDULE',
    REQUEST_DELETE_SCHEDULE = '@chatSchedule/REQUEST_DELETE_SCHEDULE',
    REQUEST_GET_SCHEDULES = '@chatSchedule/REQUEST_GET_SCHEDULES',
    REQUEST_UPDATE_SCHEDULE = '@chatSchedule/REQUEST_UPDATE_SCHEDULE',
}

export type MonthString = string;
export type DayString = string;

export type ChatScheduleState = {
    isLoading: boolean;
    isSaving: boolean;
    chatSchedules: ChatSchedule[];
    error?: string;
};

export type ChatScheduleAction<Payload> = {
    type: ChatScheduleTypes;
    payload: Payload;
};

export type ChatSchedule = {
    id: string;
    startTime: Timestamp;
    endTime: Timestamp;
};

export type ChatScheduleJs = {
    id: string;
    startTime: Date;
    endTime: Date;
};

export type DateRange = {
    startTime: Date;
    endTime: Date;
};
